import React from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { X } from "lucide-react";

const AboutModal = ({ isOpen, onClose }) => (
  <Dialog open={isOpen} onClose={onClose} className="relative z-[100]">
    <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
    <div className="fixed inset-0 flex items-center justify-center overflow-y-auto p-4">
      <DialogPanel className="max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-2xl bg-white p-6 text-gray-900 shadow-2xl sm:p-8">
        <div className="flex items-start justify-between gap-4">
          <div>
            <DialogTitle className="text-2xl font-semibold">System Requirements</DialogTitle>
            <p className="mt-1 text-sm text-gray-600">
              Computer requirements for your virtual sessions.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close requirements"
            className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#22AAEE]"
          >
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>

        <div className="mt-6 space-y-5 text-sm leading-relaxed">
          <p>Use a desktop or laptop for the browser version of Plutonic.</p>
          <section aria-labelledby="about-minimum">
            <h3 id="about-minimum" className="text-base font-semibold">Minimum specs (estimated)</h3>
            <ul className="mt-2 list-disc space-y-2 pl-5">
              <li><strong>Memory:</strong> 8 GB RAM.</li>
              <li><strong>Processor:</strong> Intel Core i5, 8th generation or newer, or AMD Ryzen 5 3000 series or newer.</li>
              <li><strong>Graphics:</strong> Integrated graphics supporting WebGL 2, using Low graphics settings. Performance varies by graphics model.</li>
            </ul>
          </section>
          <section aria-labelledby="about-recommended" className="rounded-xl bg-[#D8F8FF]/50 p-4">
            <h3 id="about-recommended" className="text-base font-semibold">Recommended specs</h3>
            <ul className="mt-2 list-disc space-y-2 pl-5">
              <li><strong>Memory:</strong> 16 GB RAM.</li>
              <li><strong>Processor:</strong> Intel Core i5, 11th generation or newer, or AMD Ryzen 5 5000 series or newer.</li>
              <li><strong>Graphics:</strong> Intel Iris Xe, AMD Radeon integrated graphics of comparable capability, or a dedicated graphics card of comparable or better performance.</li>
            </ul>
          </section>
          <section aria-labelledby="about-session-setup">
            <h3 id="about-session-setup" className="text-base font-semibold">Before you join</h3>
            <ul className="mt-2 list-disc space-y-2 pl-5">
              <li>Use current 64-bit Google Chrome or Microsoft Edge with hardware acceleration enabled.</li>
              <li>Use a stable broadband connection. A headset with a microphone is recommended for voice chat.</li>
              <li>Close unused tabs and applications. If the space feels slow, select Low graphics settings.</li>
            </ul>
          </section>
          <p className="text-xs text-gray-600">
            These hardware targets are estimates pending performance testing.
            Performance varies by virtual space, session activity, and other apps
            running on your computer. Try your space and audio before your first session.
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="mt-6 w-full rounded-full bg-[#22AAEE] px-6 py-3 font-semibold text-white hover:bg-[#168dcc] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#22AAEE]"
        >
          Done
        </button>
      </DialogPanel>
    </div>
  </Dialog>
);

export default AboutModal;
